import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {jobApplicationsEdit_template} from "../components/templates/jobApplicationsEdit_template";
import {header} from "./header";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";

declare var ko: any;
declare var page: any;

let editor;

export class job_applications_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: jobApplicationsEdit_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName(){

        return "job_applications_edit";
    }

    buildContent() : Array<Element>{

        // create the jobs form
        this.editForm = new jobApplicationsEdit_template("editForm", this.viewModel, this);
        let vnApp = this.getVnAppZone().app;
        this.editForm.setIdLoggedUser(vnApp.loggedUser.user.id);

        return [this.editForm.build()];
    }

    public cancelForm(){

        this.redirectToListPage();
    }

    public redirectToListPage() {

        let previousUrl = this.loadPreviousPage(window.location.href);
        if(previousUrl){
            page.redirect(previousUrl);
        }else{
            page('/job/applications');
        }
    }

    public fillPage() : void{

        this.getData();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected getData(){

        this.loadingIn(this.editForm.builtTemplate);

        let id: number;

        if ((id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.editForm.getTemplateViewModel().id(id);
        }
        let usrReq_url: string = '/api/job/applications/get/' + id;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetFormDataReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                    obj.editForm.setIsCandidate(responseParsed.isCandidate);
                    obj.editForm.setPermissions(responseParsed.permissions);
                    obj.editForm.setHrStatusOptions(responseParsed.hrStatusOptions);
                    obj.editForm.setApplicationStatusOptions(responseParsed.applicationStatusOptions);
                    obj.editForm.setConfigOptions(responseParsed.configOptions || []);
                    obj.editForm.setUpForm(responseParsed.data);
                    obj.editForm.setInternalNotes(responseParsed.internalNotes);
                    obj.editForm.setApplicationHistory(responseParsed.applicationHistory);
                    obj.editForm.setRejectionReasons(responseParsed.rejectionReasons);

                    obj.setUpCkEditor();
                    obj.loadingOut(obj.editForm.builtTemplate);
            })
        }
    }

    public getSavePostData(){

        return {

            id: this.editForm.getTemplateViewModel().id(),
            candidateName: this.editForm.getTemplateViewModel().candidateName(),
            candidateEmail: this.editForm.getTemplateViewModel().candidateEmail(),
            status: this.editForm.getTemplateViewModel().status(),
            positionTitle: this.editForm.getTemplateViewModel().positionTitle(),
            resume: this.getResume(),
            coverLetter: this.getCoverLetter(),
            writtenSample: this.getWrittenSample(),
            imageSample: this.getImageSample(),
            referentialWork: this.editForm.getTemplateViewModel().referentialWork(),
            answers: this.editForm.getTemplateViewModel().answers(),
            isSampleSubmitted: this.editForm.getTemplateViewModel().isSampleSubmitted(),
            idHrStatus: this.editForm.getTemplateViewModel().idHrStatus(),
            idApplicationStatus: this.editForm.getTemplateViewModel().idApplicationStatus(),
            text: editor ? editor.getData() : '',
            rejectionReason: (this.editForm.getTemplateViewModel().selectedReason() ?this.editForm.getTemplateViewModel().selectedReason() : null),
        }

    }

    protected getResume(){

        let resume: any = {};
        if(this.editForm.getTemplateViewModel().resume()){

            resume.id = this.editForm.getTemplateViewModel().resume().id;
            resume.path = ''
        }

        if(this.editForm.getTemplateViewModel().resumeFile()){

            resume.path = this.editForm.getTemplateViewModel().resumeFile().path;
        }

        return resume;
    }

    protected getCoverLetter(){

        let coverLetter: any = {};
        if(this.editForm.getTemplateViewModel().coverLetter()){

            coverLetter.id = this.editForm.getTemplateViewModel().coverLetter().id;
            coverLetter.path = '';
        }

        if(this.editForm.getTemplateViewModel().coverLetterFile()){

            coverLetter.path = this.editForm.getTemplateViewModel().coverLetterFile().path
        }

        return coverLetter;
    }

    protected getWrittenSample(){

        let writtenSample: any = {} ;
        if(this.editForm.getTemplateViewModel().writtenSample()){

            writtenSample.id = this.editForm.getTemplateViewModel().writtenSample().id;
            writtenSample.instructions = this.editForm.getTemplateViewModel().writtenSample().instructions;
            writtenSample.path = '';

        }
        if(this.editForm.getTemplateViewModel().writtenSampleFile()){

            writtenSample.path = this.editForm.getTemplateViewModel().writtenSampleFile().path;
        }

        return writtenSample;
    }

    protected getImageSample(){

        let imageSample: any = {} ;
        if(this.editForm.getTemplateViewModel().imageSample() ){

            imageSample.id = this.editForm.getTemplateViewModel().imageSample().id;
            imageSample.instructions = this.editForm.getTemplateViewModel().imageSample().instructions;
            imageSample.path = [];

        }

        if(this.editForm.getTemplateViewModel().imageSampleFiles().length > 0){

            let paths = [];
            let files = this.editForm.getTemplateViewModel().imageSampleFiles();
            for(let file of files){

                paths.push(file.path);
            }
            imageSample.path = paths;
        }

        return imageSample;
    }

    protected save(){

        this.loadingIn(this.editForm.builtTemplate);

        // get the ckEditor text
        // this.editForm.getTemplateViewModel().text(editor.getData());

        let formReq_url: string = '/api/job/applications/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.getSavePostData();
        console.log("subViewModel", subViewModel);
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Application saved successfully !");

                    obj.redirectToListPage();
                })
                obj.loadingOut(obj.editForm.builtTemplate);

            }
        });
        XHRHdl.execute();
    }

    protected setUpCkEditor(){

        let element = document.querySelector( '#writtenSample' );
        let text = this.editForm.getTemplateViewModel().writtenSampleText()

        if(element) {
            classicEditor.create(element, {
                toolbar: ['heading', 'bold', '|', 'italic', 'link', 'bulletedList', 'numberedList', 'indent'],
                removePlugins: ['image']
            })
            .then(newEditor => {
                editor = newEditor;
                editor.setData(text);
            })
            .catch(error => {
                console.error(error);
            });
        }
    }

    protected addComment(isInternal){

        let formReq_url: string = '/api/job/applications/comments/save/';
        let formReq_params: Array<Array<string>> = [];

        let value = '';
        if(isInternal){
            value = this.editForm.getTemplateViewModel().internalNote();
            this.loadingIn(this.editForm.builtTemplate.querySelector('#internal-notes'));
        }else{
            value = this.editForm.getTemplateViewModel().comment();
            this.loadingIn(this.editForm.builtTemplate.querySelector('#external-comments'));
        }

        let subViewModel = {id: this.editForm.getTemplateViewModel().id(), comment: value, 'isInternal': isInternal}
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateCommentsAndInternalNotes(responseParsed.data);
                    if(isInternal){
                        obj.loadingOut(obj.editForm.builtTemplate.querySelector('#internal-notes'));
                    }else {
                        obj.loadingOut(obj.editForm.builtTemplate.querySelector('#external-comments'));
                    }
                });
            }
        });
        XHRHdl.execute();
    }

    protected deleteComment(data, isInternal){

        if(isInternal){
            this.loadingIn(this.editForm.builtTemplate.querySelector('#internal-notes'));
        }else{
            this.loadingIn(this.editForm.builtTemplate.querySelector('#external-comments'));
        }

        let formReq_url: string = '/api/job/applications/comments/delete/' + data.id;
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = {'isInternal': isInternal}
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateCommentsAndInternalNotes(responseParsed.data);
                    if(isInternal){
                        obj.loadingOut(obj.editForm.builtTemplate.querySelector('#internal-notes'));
                    }else{
                        obj.loadingOut(obj.editForm.builtTemplate.querySelector('#external-comments'));
                    }
                });
                obj.loadingOut(obj.editForm.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    protected updateCommentsAndInternalNotes(data){

        this.editForm.setComments(data.comments)
        this.editForm.setInternalNotes(data.internalNotes)
        this.editForm.getTemplateViewModel().comment('')
        this.editForm.getTemplateViewModel().internalNote('');
    }

}


// WEBPACK FOOTER //
// ./js/modules/job_applications_edit.ts